import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Table, Col, Button, Form } from "react-bootstrap";
import { FormControl, Select, InputLabel, MenuItem } from "@material-ui/core";
import BasicPagination from "../../../Pagination/Pagination";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import ViewEventDetailsOnline from "./ViewEventDetailsOnline";
import EventsList from "./EventsList";
import ViewEventDetailsOffline from "./ViewEventDetailsOffline";
import moment from "moment";
import {
  get_all_events,
  update_admin_event,
  delete_event_admin,
} from "../../../../store/actions/SuperAdminActions/commonSuperAdmin";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import { SortComponent } from "../../../reusableComponents/SortAndFilterComponent/SortComponent";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { ADMIN_EDIT_EVENT_DETAILS_ADMIN } from "../../../../store/types";

const offerTypes = [
  { id: 0, title: "All" },
  { id: 1, title: "Online" },
  { id: 2, title: "Offline" },
];

const SuperAdminRestaurantEvents = (props) => {
  //state
  const dispatch = useDispatch();
  let history = useHistory();
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const [page, setPage] = useState(1);
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
    //page = pageNo;
  };

  const [showView, setShowView] = useState(false);
  const [showView2, setShowView2] = useState(false);
  const [dataOnline, setDataOnline] = useState();
  const [dataOffline, setDataOffline] = useState();

  const handleShowView = (offer) => {
    setDataOnline(offer);
    setShowView(true);
  };
  const handleShowView2 = (offer) => {
    setDataOffline(offer);
    setShowView2(true);
  };
  const handleCloseView = () => setShowView(false);
  const handleCloseView2 = () => setShowView2(false);
  const [showDeleteEvent, seShowDeleteEvent] = useState(false);
  const handleOpenDeleteEventModel = () => {
    seShowDeleteEvent(true);
  };
  const handleCloseDeleteEvent = () => {
    seShowDeleteEvent(false);
  };

  const [search, setSearch] = useState("");
  const [sortByDay, setSortByDay] = useState(4);
  const [startDay, setStartDay] = useState("");
  const [endDay, setEndDay] = useState("");
  const [isonline, setisonline] = useState("All");

  const [state, setState] = useState({
    anchorEl: null,
    showFilter: false,
    offerType: "All",
  });

  const handleShowFilter = () => {
    setState({
      ...state,
      showFilter: !state.showFilter,
    });
  };

  const handleShowFilterClosed = () => {
    setState({
      ...state,
      showFilter: false,
    });
  };

  const onSearchClick = () => {
    setisonline(state.offerType);
    handleShowFilterClosed();
  };

  const [sortBy, setSortBy] = useState("");
  const handleClick = (event) => {
    setState({
      ...state,
      anchorEl: event.currentTarget,
    });
  };
  const handleClose = () => {
    setState({
      ...state,
      anchorEl: null,
    });
  };
  const handleSelect = (value) => (e) => {
    setSortBy(value);
    handleClose();
  };

  const changeSortByDay = (e) => {
    setSortByDay(e);
    let startDate = "";
    let endDate = new Date();
    if (e === 2) {
      startDate = new Date(new Date().setDate(new Date().getDate() - 30));
      setStartDay(moment(startDate).format("YYYY-MM-DD"));
      setEndDay(moment(endDate).format("YYYY-MM-DD"));
    } else if (e === 1) {
      startDate = new Date();
      setStartDay(moment(startDate).format("YYYY-MM-DD"));
      setEndDay(moment(endDate).format("YYYY-MM-DD"));
    } else if (e === 3) {
      startDate = new Date(new Date().setDate(new Date().getDate() - 90));
      setStartDay(moment(startDate).format("YYYY-MM-DD"));
      setEndDay(moment(endDate).format("YYYY-MM-DD"));
    }
  };
  var filteredData = [];
  filteredData =
    props &&
    props.all_events &&
    props.all_events.filter((item) => {
      return (
        (item &&
          item.name &&
          item.name.toLowerCase().includes(search.toLowerCase())) ||
        (item &&
          item.restaurant_id &&
          item.restaurant_id.restaurant_name &&
          item.restaurant_id.restaurant_name
            .toLowerCase()
            .includes(search.toLowerCase()))
      );
    });

  if (sortBy === "A-Z") {
    filteredData = filteredData.sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });
  } else if (sortBy === "Z-A") {
    filteredData = filteredData.sort((a, b) => {
      if (a.name < b.name) return 1;
      if (a.name > b.name) return -1;
      return 0;
    });
  }
  if (isonline === "All") {
    filteredData = filteredData;
  } else if (isonline === "Online") {
    filteredData = filteredData.filter((offer) => {
      if (offer.isOnline) {
        return offer;
      } else {
        return false;
      }
    });
  } else if (isonline === "Offline") {
    filteredData = filteredData.filter((offer) => {
      if (!offer.isOnline) {
        return offer;
      } else {
        return false;
      }
    });
  }

  if (sortByDay !== 4) {
    filteredData = filteredData.filter((item) => {
      return (
        (startDay <= moment(item.createdAt).format("YYYY-MM-DD") ||
          startDay <= moment(item.updatedAt).format("YYYY-MM-DD")) &&
        (moment(item.createdAt).format("YYYY-MM-DD") <= endDay ||
          moment(item.updatedAt).format("YYYY-MM-DD") <= endDay)
      );
    });
  }

  const onSuccessEdit = () => {
    handleCloseView();
    handleCloseDeleteEvent();
    const token = props.auth.user.accessToken;
    props.get_all_events(token, onSuccess);
  };

  const deleteEvent = (eventId) => {
    const token = props.auth.user.accessToken;
    props.delete_event_admin(token, eventId, onSuccessEdit);
  };

  const deleteEventOpenModal = (eventId) => {
    const token = props.auth.user.accessToken;
    props.delete_event_admin(token, eventId._id, onSuccessEdit);
  };

  const onUpdateEvent = (status, type, eventId) => {
    const formData = {};
    if (type === 1) {
      formData.send_to_carousel = status;
    } else if (type === 2) {
      formData.active = status;
    } else if (type === 3) {
      formData.mark_as_primary = status;
    }
    const token = props.auth.user.accessToken;
    props.update_admin_event(token, formData, eventId, onSuccessEdit);
  };

  const onClickEditAction = (event) => {
    dispatch({
      type: ADMIN_EDIT_EVENT_DETAILS_ADMIN,
      payload: event,
    });
    if (event?.isOnline) {
      history.push({
        pathname: `/superadminrestaurantevents/edit-online-event/${event?._id}`,
        state: { admin_event_details: event },
      });
    } else {
      history.push({
        pathname: `/superadminrestaurantevents/edit-offline-event/${event?._id}`,
        state: { admin_event_details: event },
      });
    }
  };

  const onSuccess = () => {};

  useEffect(() => {
    const token = props.auth.user.accessToken;
    props.get_all_events(token, onSuccess);
  }, []);

  return (
    <React.Fragment>
      {props.auth.loader ? (
        <AmealioLoader />
      ) : (
        <React.Fragment>
          <div className="container-fluid">
            <div className="row">
              <div className="left-side-panel">
                <LeftSideNavigation displayLink={1} />
              </div>
              <div className="super-admin-right-side-panel">
                <HomeReusableTopBarNavigation />
                <div className="super-admin-inside-right-side-panel">
                  <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                    <div className="f24_700_HelveticaNeue">
                      All Vendor - Events
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-4">
                      <Form.Control
                        type="text"
                        placeholder="Search by event , restaurant name"
                        // onChange={props.onChange}
                        // value={props.search}
                        onChange={(e) => setSearch(e.target.value)}
                        value={search}
                        className="amSearch"
                      />
                    </div>
                    <div className="col-3"></div>
                    <div className="col-3">
                      <div className="mr-3">
                        {/* <FormControl variant="outlined" fullWidth>
                          <InputLabel id="demo-simple-select-outlined-label">
                            Select date range
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id="demo-simple-select-outlined"
                            value={sortByDay}
                            onChange={(e) => changeSortByDay(e.target.value)}
                            label="date_range"
                          >
                            {sortBy.map((data, index) => (
                              <MenuItem key={index} value={data.id}>
                                {data.title}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl> */}
                      </div>
                    </div>
                    <div className="col-2">
                      <div className="d-flex align-items-center justify-content-between">
                        <SortComponent
                          handleClick={handleClick}
                          anchorEl={state.anchorEl}
                          handleClose={handleClose}
                          selectClick={(data) => handleSelect(data)}
                        />
                        <div className="f10-400" align="center">
                          <img
                            src={require("../../../../assets/images/iconButton/filtericon.png")}
                            width="35px"
                            alt="Filter Icon"
                            onClick={handleShowFilter}
                          />
                          <br />
                          Filter
                        </div>
                        <div className="f10-400" align="center">
                          <img
                            src={require("../../../../assets/images/iconButton/downloadicon.png")}
                            width="35px"
                            alt="Download Icon"
                          />
                          <br />
                          Download
                        </div>
                      </div>
                    </div>
                  </div>
                  {state.showFilter && (
                    <div className="row">
                      <div className="col-12">
                        <div className="enWhiteBox mt-3">
                          <Form className="row justify-content-between">
                            <Col md={5}>
                              <Form.Group>
                                <FormControl
                                  variant="outlined"
                                  className="w-100"
                                >
                                  <InputLabel htmlFor="outlined-Offer">
                                    Event Type
                                  </InputLabel>
                                  <Select
                                    value={state.offerType}
                                    onChange={(e) =>
                                      setState({
                                        ...state,
                                        offerType: e.target.value,
                                      })
                                    }
                                    label="Event Type"
                                    inputProps={{
                                      name: "Offer",
                                      id: "outlined-Location",
                                    }}
                                    IconComponent={KeyboardArrowDownIcon}
                                  >
                                    {offerTypes.map((data) => {
                                      return (
                                        <option
                                          value={data.title}
                                          key={data.id}
                                        >
                                          {data.title}
                                        </option>
                                      );
                                    })}
                                  </Select>
                                </FormControl>
                              </Form.Group>
                            </Col>
                            <Col md={12}>
                              <div className="d-flex align-items-center">
                                <Button
                                  variant="outline-secondary"
                                  className="btn-lg mr-4 px-5"
                                  onClick={handleShowFilterClosed}
                                >
                                  Cancel
                                </Button>
                                <Button
                                  variant="danger"
                                  className="btn-lg px-5"
                                  onClick={onSearchClick}
                                >
                                  Search
                                </Button>
                              </div>
                            </Col>
                          </Form>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
                    <Table>
                      <thead>
                        <tr className="super_admin_all_users_table_head">
                          <th style={{ width: "17%" }} className="f12-700">
                            Business <br />
                            Name/ID
                          </th>
                          <th style={{ width: "18%" }} className="f12-700">
                            My Event/Event Type/ <br />
                            Event ID
                          </th>
                          <th style={{ width: "10%" }} className="f12-700">
                            Start Date/
                            <br />
                            End Date
                          </th>
                          <th style={{ width: "10%" }} className="f12-700">
                            Timing
                          </th>
                          <th style={{ width: "10%" }} className="f12-700">
                            Main
                            <br />
                            Carousel
                          </th>
                          <th style={{ width: "10%" }} className="f12-700">
                            Status
                          </th>
                          <th style={{ width: "10%" }} className="f12-700">
                            Primary
                          </th>
                          <th style={{ width: "15%" }} className="f12-700">
                            Actions
                          </th>
                        </tr>
                      </thead>

                      {filteredData.slice(start, end).map((event) => (
                        <EventsList
                          handleShowView={handleShowView}
                          handleShowView2={handleShowView2}
                          event={filteredData}
                          key={event._id}
                          event={event}
                          onUpdateEvent={(status, type) =>
                            onUpdateEvent(status, type, event._id)
                          }
                          deleteEvent={() => deleteEvent(event._id)}
                          editDataAction={() => onClickEditAction(event)}
                        />
                      ))}
                    </Table>
                  </div>

                  {filteredData?.length > 0 ? (
                    <BasicPagination
                      totalRecords={filteredData.length}
                      limit={10}
                      batch={page}
                      onBatchChange={(e) => handleBatchChange(e)}
                    />
                  ) : (
                    <> </>
                  )}

                  <ViewEventDetailsOnline
                    onClickCloseView={handleCloseView}
                    onClickshowView={showView}
                    restaurantDetailFromOfferId={dataOnline}
                    showDeleteEvent={showDeleteEvent}
                    showOpenDeleteModel={handleOpenDeleteEventModel}
                    closeDeleteModal={handleCloseDeleteEvent}
                    deleteEventOnline={() => deleteEventOpenModal(dataOnline)}
                  />
                  <ViewEventDetailsOffline
                    handleCloseView={handleCloseView2}
                    showView={showView2}
                    restaurantDetailFromOfferId={dataOffline}
                    showDeleteEvent={showDeleteEvent}
                    showOpenDeleteModel={handleOpenDeleteEventModel}
                    closeDeleteModal={handleCloseDeleteEvent}
                    deleteEventOnline={() => deleteEventOpenModal(dataOffline)}
                  />
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

SuperAdminRestaurantEvents.propTypes = {
  auth: PropTypes.object.isRequired,
  get_all_events: PropTypes.func.isRequired,
  update_admin_event: PropTypes.func.isRequired,
  delete_event_admin: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  all_events: state.commonSuperAdmin.all_events,
});

export default connect(mapStateToProps, {
  get_all_events,
  update_admin_event,
  delete_event_admin,
})(SuperAdminRestaurantEvents);

const sortBy = [
  { id: 1, title: "Today" },
  { id: 2, title: "Last month" },
  { id: 3, title: "Last 3 months" },
  { id: 4, title: "ALL" },
];
